import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../../src/logo-icon.svg";
import logotext from "../../../src/logo-text.svg";
import useRequestsWOAccessToken from "../../utils/useRequestsWOAccessToken";
  // Formik Validation
  import * as Yup from "yup";
  import { useFormik } from "formik";
  import Snackbars from "../../utils/Snackbars";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const { postRequestWOAccessToken } = useRequestsWOAccessToken();
  const email = location.state?.email || "";
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  
  
   const [AlertData, setAlertData] = React.useState({
      variant: '',
      message: '',
    });
    const resetAlertData = () => {
      setTimeout(() => {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: '',
          message: '',
        }));
      }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
    };

  React.useEffect(() => {
      if (location.state && typeof location.state.message !== 'undefined') {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: location.state.status,
          message: location.state.message,
        }));
        resetAlertData();
      }
    }, []);

  const validation1 = useFormik({
      enableReinitialize: true,
  
      initialValues: {
        email: email,
        newPassword:'',
        confirmPassword:'',
        
      },
      validationSchema: Yup.object({
        email: Yup.string()
          .email('Please enter a valid email!')
          .max(255)
          .required('Login Email is required'),
        newPassword:Yup.string()
          .required('New password is required')
          .min(8, "Password must be at least 8 characters long!")
          .max(20, "Password must not exceed 20 characters!"),
        confirmPassword: Yup.string()
          .required('Confirm new password')
          .oneOf([Yup.ref("newPassword"), null], "Passwords must match!")
       
      }),
    onSubmit: async ( values) => {
    // e.preventDefault();
    
    try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = ('Processing...');

    
      const jsonpar = JSON.stringify({
        email:values.email,
        newPassword:values.newPassword, 
        confirmPassword:values.confirmPassword
       });
   
      const res = await postRequestWOAccessToken("reset-password", jsonpar);

      if (res && res.code === 200) {
        setAlertData({ variant: "success", message: "Password reset successfully!" });
        setTimeout(() => {
        navigate("/login", 
          {state:{variant: "success", message: "Password reset successfully!" }
        }); // Redirect to login page on success
      }, 2000);
      } else {
       
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: res.message || "Failed to reset password.",
        }));
      resetAlertData();
      }
      submit1.disabled = false;
      submit1.textContent = ('Submit');
    } catch (error) {
      console.error("Error:", error);
     
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message:  "An error occurred. Please try again later.",
      }));
    resetAlertData();
    }
  }
});
  return (
    <div className="login-main-page">
      <div className="login-wrapper">
        <div className="row m-0 justify-content-center h-100 align-items-center">
          <div className="col-xl-12">
            <Link to="/dashboard" className="logo-center">
              <img src={logo} alt="" className="logo-icon" />
              <img src={logotext} alt="" className="logo-text" />
            </Link>
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form-1">
                    <div className="mb-4">
                      <h3 className="text-primary mb-1 text-center font-w600">Reset Password</h3>
                    </div>
                     {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
                    <form >
                      <div className="form-group">
                        <label className="text-primary mb-2">
                          <span className="text-primary">Email:</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={validation1.values.email || ''}
                          disabled={true}
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-primary mb-2">
                          <span className="text-primary">New Password:</span>
                        </label>
                        <input
                          name="newPassword"
                          type="password"
                         placeholder="Please Enter New Password"
                          className={`form-control ${validation1.touched.newPassword && validation1.errors.newPassword ? 'is-invalid' : ''}`}
                          value={validation1.values.newPassword || ""}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          invalid={
                            validation1.touched.newPassword && validation1.errors.newPassword ? true : false
                          }
                        />
                        {validation1.touched.newPassword && validation1.errors.newPassword ? (
                          <div className="invalid-feedback" >{validation1.errors.newPassword}</div>
                        ) : null}
                      </div>
                      <div className="form-group">
                        <label className="text-primary mb-2">
                          <span className="text-primary">Confirm Password:</span>
                        </label>
                        <input
                          name="confirmPassword"
                          type="password"
                          placeholder="Please Confirm New Password"
                          className={`form-control ${validation1.touched.confirmPassword && validation1.errors.confirmPassword ? 'is-invalid' : ''}`}
                          value={validation1.values.confirmPassword || ""}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          invalid={
                            validation1.touched.confirmPassword && validation1.errors.confirmPassword ? true : false
                          }
                         

                        />
                        {validation1.touched.confirmPassword && validation1.errors.confirmPassword ? (
                          <div className="invalid-feedback" >{validation1.errors.confirmPassword}</div>
                        ) : null}
                      </div>
                      
                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn bg-primary text-white btn-block"
                          id="submit1"
                        onClick={(e) => {
                          e.preventDefault();
                          validation1.handleSubmit();
                          return false;
                        }}>
                        {('Submit')}
                        </button>
                      </div>
                      <div className="text-center mt-4">
                        <Link to="/login">Back to Login</Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
